/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSeoFragment, SeoFragment, FullSeoFragment} from '@amblique/contentful/app/contentful/fragments/seo';

/**
 * Get a single Seo by ID (base - scalars only)
 */
export const getBaseSeoById = gql`
  ${BaseSeoFragment}

  query GetBaseSeoById($id: String!, $locale: String!, $preview: Boolean) {
    seo(id: $id, locale: $locale, preview: $preview) {
      ...BaseSeoFragment
    }
  }
`;

/**
 * Get a single Seo by ID (standard - 1 level deep)
 */
export const getSeoById = gql`
  ${SeoFragment}

  query GetSeoById($id: String!, $locale: String!, $preview: Boolean) {
    seo(id: $id, locale: $locale, preview: $preview) {
      ...SeoFragment
    }
  }
`;

/**
 * Get a single Seo by ID (full - 2 levels deep)
 */
export const getFullSeoById = gql`
  ${FullSeoFragment}

  query GetFullSeoById($id: String!, $locale: String!, $preview: Boolean) {
    seo(id: $id, locale: $locale, preview: $preview) {
      ...FullSeoFragment
    }
  }
`;

/**
 * Get all Seo entries with pagination (base - scalars only)
 */
export const getBaseSeos = gql`
  ${BaseSeoFragment}

  query GetBaseSeos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SeoOrder]
    $where: SeoFilter
    $preview: Boolean
  ) {
    seoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSeoFragment
      }
    }
  }
`;

/**
 * Get all Seo entries with pagination (standard - 1 level deep)
 */
export const getSeos = gql`
  ${SeoFragment}

  query GetSeos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SeoOrder]
    $where: SeoFilter
    $preview: Boolean
  ) {
    seoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SeoFragment
      }
    }
  }
`;

/**
 * Get all Seo entries with pagination (full - 2 levels deep)
 */
export const getFullSeos = gql`
  ${FullSeoFragment}

  query GetFullSeos(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SeoOrder]
    $where: SeoFilter
    $preview: Boolean
  ) {
    seoCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSeoFragment
      }
    }
  }
`;
